<template>
  <b-container fluid>
    <PortalNavbar></PortalNavbar>
    <b-row style="text-align: center" class="mt-3">
      <b-col>
        <h5>
          चंद्रपुर जिल्हा सुरक्षा रक्षक मंडळाच्या समुच्चय (pool) मूळ कागदपत्र पडताळणीचे वेळापत्रक
        </h5>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col></b-col>
      <b-col md="7"> 
        <b-table stacked="md"
          bordered
          striped :items="items"></b-table>
      </b-col>
      <b-col></b-col>
    </b-row>
  </b-container>
</template>
<script>
import PortalNavbar from "@/components/PortalNavbar";
import apis from "@/apis"

export default {
  components:{PortalNavbar},
  data(){
    return{
      items:[]
    }
  },
  mounted(){
    let promiseList = apis.getSchedule();

    promiseList.then(response=>{
      if(response.status==200){
        this.items = response.body
      }
    })
    .catch(err=>{
      console.error(err);
      alert("Error is displaying the data. Please try after some time.");
    })
  }
  
}
</script>


// WEBPACK FOOTER //
// src/components/ScheduleList.vue